export function NotFound(){
    return <section>
        <img  src={"/assets/imgs/eror 404.png"} alt="not found" style={{width : "100%"}}/>
    </section>
}